// import components
import { ControlledToggleButtonGroup } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import { InvoicingAndTravelSettingsProps } from './InvoicingAndTravelSettings.types';

const InvoicingAndTravelSettings = ({
  control,
  disabled
}: InvoicingAndTravelSettingsProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'hoursTable.dutyInformation.invoicingAndTravelExpenses'
  });

  return (
    <MultiStepForm.Section
      key={'invoicingAndTravelExpenses'}
      title={t('title')}
      validateFields={['invoicing', 'buh']}
    >
      <ControlledToggleButtonGroup
        control={control}
        name="invoicing"
        label={t('invoicing')}
        direction="row"
        disabled={disabled}
        inputToggleButtons={[
          {
            label: t('exclude'),
            value: 'INVOICE_BLOCKED'
          },
          {
            label: t('invoicingUnblocked'),
            value: 'INVOICE_UNBLOCK'
          }
        ]}
      />

      <ControlledToggleButtonGroup
        control={control}
        name="buh"
        label={t('buh')}
        direction="row"
        disabled={disabled}
        inputToggleButtons={[
          {
            label: t('exclude'),
            value: 'BUH_BLOCKED'
          },
          {
            label: t('buhUnblocked'),
            value: 'BUH_DEBLOCK'
          }
        ]}
      />
    </MultiStepForm.Section>
  );
};

export default InvoicingAndTravelSettings;
